import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UserApiService from "@/core/services/api.service.user";
import moment from "moment";

export default {
  props: {
    modal: {
      default: false
    },
    value: Boolean
  },
  name: "onboarding-partners-list",
  data() {
    return {
      pageSizes: [10, 20, 50, 100],
      userName: "",
      userId: "",
      email: "",
      address: "",
      iban: "",
      onboardTypes: [],
      subscriptionStatus: [],
      dateFrom: null,
      dateTo: null,
      dates: [],
      dateRangeMenu: false,
      userCities: [],
      citiesIsLoading: false,
      shopName: "",
      search: "",
      totalPartners: 0,
      partners: [],
      allPartners: [],
      loading: false,
      pagination: {},
      dialogTest: false,
      showProfileDialog: false,
      userProfile: null,
      notifications: false,
      sound: true,
      widgets: false,
      loader: null,
      errors: [],
      status: "",
      onboardTypesFromApi: {}
    };
  },
  computed: {
    name() {
      return this.$i18n.t("menu.onboardingPartners");
    },
    headersMobile() {
      return [
        {
          text: "Id",
          align: "start",
          value: "id",
          width: "50%"
        },
        { text: this.$i18n.t("common.email"), value: "email", sortable: false },
        {
          text: "Creation Date",
          value: "creationDate",
          sortable: false,
          width: "10%"
        },
        {
          text: this.$i18n.t("pages.partners.subscription"),
          value: "subscription",
          sortable: false,
          width: "15%"
        }
      ];
    },
    headers() {
      return [
        { text: "ID", align: "start", value: "id", width: "5%" },
        { text: this.$i18n.t("common.email"), value: "email", sortable: false, width: "20%" },
        {
          text: this.$i18n.t("common.address"),
          value: "address",
          sortable: false,
          width: "10%"
        },
        {
          text: this.$i18n.t("common.iban"),
          value: "iban",
          sortable: false,
          width: "10%"
        },
        {
          text: "Creation Date",
          value: "creationDate",
          sortable: false,
          width: "20%",
          align: "center"
        },
        {
          text: this.$i18n.t("pages.partners.onboardType"),
          value: "subscriptionName",
          width: "20%",
          sortable: false,
          align: "center"
        },
        {
          text: this.$i18n.t("pages.partners.subscriptionStatus"),
          value: "subscriptionStatus",
          width: "20%",
          sortable: false,
          align: "center"
        }
      ];
    },

    allSubscriptionStatuses() {
      return [
        {
          customText: this.$i18n.t("pages.partners.subscriptionStatuses.active"),
          value: "ACTIVE"
        },
        {
          customText: this.$i18n.t("pages.partners.subscriptionStatuses.pending"),
          value: "PENDING"
        },
        {
          customText: this.$i18n.t("pages.partners.subscriptionStatuses.canceled"),
          value: "CANCELED"
        },
        {
          customText: this.$i18n.t("pages.partners.subscriptionStatuses.expired"),
          value: "EXPIRED"
        }
      ];
    },
    allOnboardTypes() {
      // If API data is available, use it; otherwise fallback to hardcoded values
      if (Object.keys(this.onboardTypesFromApi).length > 0) {
        return Object.entries(this.onboardTypesFromApi).map(([value, customText]) => ({
          customText,
          value
        }));
      }

      // Fallback to hardcoded values if API data is not yet loaded
      return [
        {
          customText: this.$i18n.t("pages.onboardTypes.partner"),
          value: "PARTNER"
        },
        {
          customText: this.$i18n.t("pages.onboardTypes.partnerNew"),
          value: "PARTNER_NEW"
        },
        {
          customText: this.$i18n.t("pages.onboardTypes.partnerNow"),
          value: "PARTNER_NOW"
        },
        {
          customText: this.$i18n.t("pages.onboardTypes.partnerWeekly"),
          value: "PARTNER_NOW_WEEKLY"
        },
        {
          customText: this.$i18n.t("pages.onboardTypes.partnerQuarterly"),
          value: "PARTNER_QUARTERLY"
        },
        {
          customText: this.$i18n.t("pages.onboardTypes.tester"),
          value: "TESTER"
        },
        {
          customText: this.$i18n.t("pages.partners.subscriptionStatuses.weeklyTrial3Days"),
          value: "PARTNER_WEEKLY_3_DAYS_TRIAL"
        }
      ];
    },
    dateRangeText() {
      if (!this.dates || this.dates.length === 0) {
        return "";
      }
      if (this.dates.length === 1) {
        return moment(this.dates[0]).format("DD.MM.YYYY");
      }
      if (this.dates.length === 2) {
        const sortedDates = [...this.dates].sort();
        return `${moment(sortedDates[0]).format("DD.MM.YYYY")} - ${moment(sortedDates[1]).format(
          "DD.MM.YYYY"
        )}`;
      }
      return "";
    }
  },
  watch: {
    pagination: {
      handler() {
        this.retrievePartners();
        this.getOnboardingPartnerFilterTypes();
      },
      deep: true
    }
  },
  created() {
    UserApiService.init();
  },
  methods: {
    /* eslint-disable */
    isMobile() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    getTranslatedSubscriptionName(subscriptionName) {
      if (this.onboardTypesFromApi && this.onboardTypesFromApi[subscriptionName]) {
        return this.onboardTypesFromApi[subscriptionName];
      }

      return subscriptionName;
    },

    getUserCreationDate(user) {
      return moment(user.createDate).format("DD.MM.YYYY");
    },

    getRequestParams(
      userName,
      email,
      dateFrom,
      dateTo,
      userId,
      subscriptionStatus,
      address,
      iban,
      onboardTypes
    ) {
      let params = {};

      if (userName) {
        params["username"] = userName;
      }

      if (email) {
        params["email"] = email;
      }

      if (dateFrom) {
        params["createdAtFrom"] = moment(dateFrom).format("YYYY-MM-DDTHH:mm:ss");
      }

      if (dateTo) {
        params["createdAtTo"] = moment(dateTo).format("YYYY-MM-DDTHH:mm:ss");
      }

      if (userId) {
        params["userId"] = userId;
      }

      if (subscriptionStatus) {
        params["statuses"] = subscriptionStatus;
      }

      if (address) {
        params["address"] = address;
      }

      if (iban) {
        params["iban"] = iban;
      }

      if (onboardTypes) {
        params["onboardTypes"] = onboardTypes;
      }

      let sort;
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        sort = sortBy[0];
        if (sortDesc[0] === true) sort += ",desc";
      }
      params["sort"] = sort;
      params["page"] = this.pagination.page - 1;
      params["size"] = this.pagination.itemsPerPage;

      return params;
    },
    clearSearch() {
      (this.userName = ""),
        (this.email = ""),
        (this.dateFrom = null),
        (this.dateTo = null),
        (this.dates = []),
        (this.subscriptionStatus = ""),
        (this.userId = ""),
        (this.address = ""),
        (this.iban = ""),
        (this.onboardTypes = []);
    },
    async getOnboardingPartnerFilterTypes() {
      try {
        const response = await UserApiService.getOnboardingPartnerFilterTypes();
        // Store the API response data for use in allOnboardTypes computed property
        this.onboardTypesFromApi = response.data;
      } catch (error) {
        console.error("Error fetching onboarding partner filter types:", error);
      }
    },
    retrievePartners() {
      const params = this.getRequestParams(
        this.userName,
        this.email,
        this.dateFrom,
        this.dateTo,
        this.userId,
        this.subscriptionStatus,
        this.address,
        this.iban,
        this.onboardTypes
      );

      return new Promise(resolve => {
        this.loading = true;
        UserApiService.getOnboardingPartners(params)
          .then(response => {
            // Map the new API response structure to the component data
            this.partners = response.data.content.map(item => ({
              id: item.user.id,
              userId: item.user.userId,
              username: item.user.username,
              email: item.paymentData?.email || item.user.email,
              name: item.paymentData?.fullName || item.user.fullName,
              address: item.paymentData
                ? `${item.paymentData?.cityName}, ${item.paymentData?.countryName}`
                : `${item.user.cityName}, ${item.user.countryName}`,
              iban: item.paymentData?.iban || item.user.iban,
              shopName: item.user.name,
              mobile: item.user.mobile,
              description: item.user.description,
              website: item.user.website,
              createDate: item.user.createDate,
              countryName: item.user.countryName,
              cityName: item.user.cityName,
              orderCount: item.user.orderCount,
              category: item.user.category,
              // Subscription data
              subscriptionId: item.userSubscription.id,
              subscriptionName: item.userSubscription.onboardType,
              subscriptionPrice: item.userSubscription.price,
              subscriptionType: item.userSubscription.type,
              paymentType: item.userSubscription.paymentType,
              paymentImage: item.userSubscription.paymentImage,
              startedAt: item.userSubscription.startedAt,
              endsAt: item.userSubscription.endsAt,
              subscriptionStatus: item.userSubscription.status,
              canceled: item.userSubscription.canceled,
              active: item.userSubscription.active,
              trial: item.userSubscription.trial,
              trialDays: item.userSubscription.trialDays,
              // Payment data
              paymentData: item.paymentData
                ? {
                    iban: item.paymentData.iban,
                    fullName: item.paymentData.fullName,
                    phone: item.paymentData.phone,
                    address: item.paymentData.address,
                    postCode: item.paymentData.postCode,
                    createdAt: item.paymentData.createdAt,
                    updatedAt: item.paymentData.updatedAt
                  }
                : null,
              // Subscription plan details
              subscriptionPlan: {
                name: item.subscription.name,
                price: item.subscription.price,
                type: item.subscription.type,
                additionalInfo: item.subscription.additionalInfo,
                benefits: item.subscription.benefits,
                hasFreeTrial: item.subscription.hasFreeTrial,
                subtitle: item.subscription.subtitle,
                givesInfluencerFlag: item.subscription.givesInfluencerFlag
              }
            }));

            this.totalPartners = response.data.total;
            this.totalPages = Math.ceil(response.data.total / response.data.size);
            this.loading = false;
            let title = this.totalPartners;
            this.$store.dispatch(SET_BREADCRUMB, [{ title: `${this.name}: ` + title }]);
            resolve();
          })
          .catch(error => {
            this.$log.error("Error fetching partners: ", error);
            this.loading = false;
            resolve();
          });
      });
    },
    async copyPaymentData(partner) {
      try {
        // Prepare the payment data text
        const paymentData = [
          `Full Name: ${partner.paymentData ? partner.paymentData.fullName : partner.username}`,
          `IBAN: ${partner.iban ? partner.iban : "N/A"}`,
          `Address: ${partner.cityName}, ${partner.countryName}` || "N/A",
          `Postal Code: ${partner.paymentData ? partner.paymentData?.postCode || "N/A" : "N/A"}`
        ].join("\n");

        // Copy to clipboard
        await navigator.clipboard.writeText(paymentData);

        // Show success message
        this.$bvToast.toast(this.$i18n.t("pages.partners.paymentDataCopied"), {
          title: "Success",
          variant: "success",
          solid: true
        });
      } catch (error) {
        console.error("Error copying payment data:", error);
        this.$bvToast.toast(this.$i18n.t("pages.partners.copyError"), {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },

    async exportOnboardingPartners() {
      const params = this.getRequestParams(
        this.userName,
        this.email,
        this.dateFrom,
        this.dateTo,
        this.userId,
        this.subscriptionStatus,
        this.address,
        this.iban,
        this.onboardTypes
      );

      this.loading = true;
      UserApiService.exportOnboardingPartners(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "onboarding_partners_report.xlsx";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          console.error("Error exporting onboarding partners: ", error);
          this.$bvToast.toast(this.$i18n.t("pages.partners.exportError"), {
            title: "Error Exporting Onboarding Partners",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => (this.loading = false));
    },

    handleDateSelection() {
      if (!this.dates || this.dates.length === 0) {
        return;
      }

      if (this.dates.length === 1) {
        // First date selected - don't close picker, wait for second selection or confirmation
        this.dateFrom = this.dates[0];
        this.dateTo = null;
        // Don't close the menu yet
      } else if (this.dates.length === 2) {
        // Two dates selected - check if they're the same (double-click scenario)
        if (this.dates[0] === this.dates[1]) {
          // Same date selected twice - set both from and to as same date
          this.dateFrom = this.dates[0];
          this.dateTo = this.dates[0];
        } else {
          // Different dates - set as range
          const sortedDates = [...this.dates].sort();
          this.dateFrom = sortedDates[0];
          this.dateTo = sortedDates[1];
        }
        // Close picker and trigger API call after second selection
        this.dateRangeMenu = false;
        this.retrievePartners();
      }
    },

    clearDateRange() {
      this.dates = [];
      this.dateFrom = null;
      this.dateTo = null;
      this.retrievePartners();
    }
  }
};
